let text_options = {
  zIndex: 5,
  draw: 'text',
  size: 12,
  font: '18px Arial',
  fillStyle: 'black',
  shadowBlur: 10,
  fontColorRange:[]
}

let region_text_options = {
  zIndex: 5,
  draw: 'text',
  size: 12,
  font: '18px Arial',
  fillStyle: 'black',
  shadowBlur: 10,
  fontColorRange:[]
}

let text_options_high = {
  textKey:'count',
  draw: 'text',
  size: 12,
  font: '18px Arial',
  fillStyle: 'white',
  shadowBlur: 10,
  zIndex: 5,
  // avoid: true,
  // fontSizeSet:{width:3, sizeOffset:0},
  fontColorRange:[]
}

let text_options_name = {
  draw: 'text',
  size: 12,
  font: '18px Arial',
  fillStyle: '#696969',
  shadowBlur: 10,
  offset: { // 文本便宜值
        x: 0,
        y: -25
    }
}

let grid_options_name = {
  draw: 'text',
  size: 12,
  font: '18px Arial',
  fillStyle: '#d0d0d0',
  shadowBlur: 10,
  zIndex: 5000,
  fontColorRange:[]
}

var options_circle = {
    zIndex: 4,
    fillStyle: 'rgba(255, 50, 50, 0)',
    strokeStyle: '#091939',
    lineWidth: 2,
    globalCompositeOperation: 'lighter',
    size: 5,
    draw: 'simple'
}
export{text_options,text_options_high,text_options_name,region_text_options,options_circle,grid_options_name}


// WEBPACK FOOTER //
// ./src/options/mapv_options.js